"use client";
import {
  PopoverContextProvider
} from "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import "../__chunks/I6MSISV2.js";
import {
  usePopoverStore
} from "../__chunks/BJY6QMBB.js";
import "../__chunks/QX2CMDZ5.js";
import "../__chunks/D6UA6CB7.js";
import "../__chunks/S67MTDSB.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import "../__chunks/4R3V3JGP.js";

// src/popover/popover-provider.tsx
import { jsx } from "react/jsx-runtime";
function PopoverProvider(props = {}) {
  const store = usePopoverStore(props);
  return /* @__PURE__ */ jsx(PopoverContextProvider, { value: store, children: props.children });
}
export {
  PopoverProvider
};
